import RepositoryService from 'src/services/repository'

function getResource (idSession) {
  return `trainingSession/${idSession}/game`
}

export default {
  getList: async idSession => {
    const resource = getResource(idSession)
    return RepositoryService.crud.getList(resource)
  },
  get: async (idSession, idGame) => {
    const resource = getResource(idSession)
    return RepositoryService.crud.get(resource, idGame)
  },
  patch: async ({ sessionId, ...data }) => {
    const resource = getResource(sessionId)
    return RepositoryService.crud.patch(resource, data)
  },
}
